import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { statusUrlFromToggleUrl, getBookmarkStatus, toggleBookmark } from '../../utilities/bookmarks/bookmark-client.js';
import { announce, showToast } from '../toast/toast-service.js';
import { DEFAULT_LABELS, DEFAULT_TOAST_COPY, parseCopy } from './bookmark-toggle.copy.js';
import css_248z from './bookmark-toggle.scss.js';

const DOUBLE_ACTIVATION_GUARD_MS = 500;
const parseBoolean = (value) => {
    const normalized = value === null || value === void 0 ? void 0 : value.trim().toLowerCase();
    if (normalized === 'true')
        return true;
    if (normalized === 'false')
        return false;
    return null;
};
class BookmarkToggle extends s {
    constructor() {
        super(...arguments);
        this.pageGuid = '';
        this.toggleEndpointUrl = '';
        this.isAuthenticated = true;
        this.labels = DEFAULT_LABELS;
        this.toastCopy = DEFAULT_TOAST_COPY;
        this.bookmarked = null;
        this.busy = false;
        this.onClick = async () => {
            if (this.busy || this.loading || !this.toggleEndpointUrl)
                return;
            if (!this.isAuthenticated) {
                this.showSignInToast();
                return;
            }
            const previous = this.bookmarked;
            const intended = !previous;
            this.bookmarked = intended;
            this.busy = true;
            const guard = new Promise(resolve => {
                setTimeout(resolve, DOUBLE_ACTIVATION_GUARD_MS);
            });
            try {
                const result = await this.requestToggle(intended);
                if (result.success) {
                    announce(intended
                        ? this.toastCopy.addedAnnouncement
                        : this.toastCopy.removedAnnouncement);
                    this.dispatchEvent(new CustomEvent('bookmark-change', {
                        detail: { pageGuid: this.pageGuid, isBookmarked: intended },
                        bubbles: true,
                        composed: true,
                    }));
                }
                else {
                    this.bookmarked = previous;
                    if (result.reason === 'unauthenticated')
                        this.showSignInToast();
                    else
                        this.showErrorToast();
                }
            }
            finally {
                await guard;
                this.busy = false;
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.bookmarked = parseBoolean(this.getAttribute('is-bookmarked'));
        if (this.bookmarked === null)
            this.loadStatus().catch(() => undefined);
    }
    async loadStatus() {
        const statusUrl = statusUrlFromToggleUrl(this.toggleEndpointUrl);
        if (!statusUrl) {
            this.bookmarked = false;
            return;
        }
        const result = await getBookmarkStatus(statusUrl);
        this.bookmarked = result.success ? result.isBookmarked : false;
    }
    get loading() {
        return this.bookmarked === null;
    }
    showSignInToast() {
        const copy = this.toastCopy;
        showToast({
            variant: 'error',
            title: copy.signInTitle,
            message: copy.signInMessage,
            durationMs: copy.durationMs,
            closeLabel: copy.closeLabel,
        });
    }
    showErrorToast() {
        const copy = this.toastCopy;
        showToast({
            variant: 'error',
            title: copy.errorTitle,
            message: copy.errorMessage,
            durationMs: copy.durationMs,
            closeLabel: copy.closeLabel,
        });
    }
    async requestToggle(intended) {
        const result = await toggleBookmark(this.toggleEndpointUrl, intended);
        if (result.success || result.reason !== 'network')
            return result;
        const statusUrl = statusUrlFromToggleUrl(this.toggleEndpointUrl);
        if (!statusUrl)
            return result;
        const status = await getBookmarkStatus(statusUrl);
        return status.success && status.isBookmarked === intended ? status : result;
    }
    render() {
        const isDisabled = this.busy || this.loading || !this.toggleEndpointUrl;
        return $ `<button type="button" class="toggle" aria-disabled="${isDisabled ? 'true' : w}" aria-busy="${this.busy ? 'true' : w}" @click="${this.onClick}"><span class="material-symbols-outlined icon ${this.bookmarked
            ? 'is-filled'
            : ''}" aria-hidden="true">star</span> <span class="label">${this.bookmarked ? this.labels.remove : this.labels.add}</span></button>`;
    }
}
BookmarkToggle.styles = css_248z;
__decorate([
    e({ attribute: 'page-guid' })
], BookmarkToggle.prototype, "pageGuid", void 0);
__decorate([
    e({ attribute: 'toggle-endpoint-url' })
], BookmarkToggle.prototype, "toggleEndpointUrl", void 0);
__decorate([
    e({ attribute: 'is-bookmarked' })
], BookmarkToggle.prototype, "isBookmarkedAttr", void 0);
__decorate([
    e({
        attribute: 'is-authenticated',
        converter: value => (value === null || value === void 0 ? void 0 : value.trim().toLowerCase()) !== 'false',
    })
], BookmarkToggle.prototype, "isAuthenticated", void 0);
__decorate([
    e({ converter: value => parseCopy(value, DEFAULT_LABELS) })
], BookmarkToggle.prototype, "labels", void 0);
__decorate([
    e({
        attribute: 'toast',
        converter: value => parseCopy(value, DEFAULT_TOAST_COPY),
    })
], BookmarkToggle.prototype, "toastCopy", void 0);
__decorate([
    t()
], BookmarkToggle.prototype, "bookmarked", void 0);
__decorate([
    t()
], BookmarkToggle.prototype, "busy", void 0);
customElements.define('bookmark-toggle', BookmarkToggle);

export { BookmarkToggle };
